import type {
  PromotedEntities,
  SportTournamentsMenuLayer,
  StagesMenuLayer,
  TournamentsMenuLayer,
  UnionsMenuLayer,
} from './types';
import {
  MENU_LAYER_TYPE,
} from './types';
import { type AnyMenuItem, MENU_ITEM_TYPE } from 'app/modules/Navigation/types';

import { ROUTE_PATH } from 'app/lib/routing/constants';

type MenuLayerFactoryProps = ('key' | 'type' | 'items' | 'visible');

export const createUnionsMenuLayer = (
  { sportId, header }: Omit<UnionsMenuLayer, MenuLayerFactoryProps>,
): UnionsMenuLayer => ({
  key: `sport-${sportId}`,
  type: MENU_LAYER_TYPE.UNIONS,
  header,
  sportId,
  visible: false,
  items: [],
});

export const createTournamentsMenuLayer = (
  { unionId, header }: Omit<TournamentsMenuLayer, MenuLayerFactoryProps>,
): TournamentsMenuLayer => ({
  key: `union-${unionId}`,
  type: MENU_LAYER_TYPE.TOURNAMENTS,
  header,
  unionId,
  visible: false,
  items: [],
});

export const createSportTournamentsMenuLayer = (
  { sportId, header }: Omit<SportTournamentsMenuLayer, MenuLayerFactoryProps>,
): SportTournamentsMenuLayer => ({
  key: `sport-${sportId}`,
  type: MENU_LAYER_TYPE.SPORT_TOURNAMENTS,
  header,
  sportId,
  visible: false,
  items: [],
});

export const createStagesMenuLayer = (
  { tournamentId, header }: Omit<StagesMenuLayer, MenuLayerFactoryProps>,
): StagesMenuLayer => ({
  key: `tournament-${tournamentId}`,
  type: MENU_LAYER_TYPE.STAGES,
  header,
  tournamentId,
  visible: false,
  items: [],
});

export const isBettingMenu = (pathname: string) => {
  return pathname === ROUTE_PATH.ROOT
    || pathname.startsWith(ROUTE_PATH.RESULTS)
    || pathname.startsWith(ROUTE_PATH.EXTERNAL_GAMES)
    || pathname.startsWith(ROUTE_PATH.PROMOTIONS)
    || pathname.startsWith(ROUTE_PATH.PREMATCH)
    || pathname.startsWith(ROUTE_PATH.LIVE);
};

// reworking src/modules/Navigation/utils.ts isSelectedMenuItem
export const isSelectedMenuItem = (
  item: AnyMenuItem,
  pathname: string,
): boolean => {
  if (pathname.includes(ROUTE_PATH.RESULTS)) {
    return false;
  }

  if (item.shortcut) {
    return false;
  }

  switch (item.type) {
    case MENU_ITEM_TYPE.CONSTANT:
      if (item.activeOn === 'betting') {
        return pathname.startsWith(ROUTE_PATH.LIVE)
          || pathname.startsWith(ROUTE_PATH.PREMATCH);
      }

      if (item.activeOn === 'exact-match') {
        return (item.location === pathname);
      }

      if (item.activeOn === 'prefix-match') {
        return pathname.startsWith(item.location);
      }

      return false;

    case MENU_ITEM_TYPE.SPORT:
    case MENU_ITEM_TYPE.UNION:
    case MENU_ITEM_TYPE.TOURNAMENT:
    case MENU_ITEM_TYPE.STAGE:
    case MENU_ITEM_TYPE.MATCH:
      return pathname.endsWith(`${item.location}`)
      || pathname.includes(`${item.location}/`);

    default:
      console.warn('unrecognized menu entry %o', item); // >>>
      return false;
  }
};

export const scrollToUnion = (promotedEntities: PromotedEntities, promotedEntityId: string) => {
  const promoterEntityRef = promotedEntities && promotedEntities[promotedEntityId];

  if (promoterEntityRef) {
    promoterEntityRef.current?.scrollIntoView({
      block: 'center',
      behavior: 'smooth',
    });
  }
};
